import React from 'react';

const BenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-battery-charge-line',
      title: 'Increased Energy',
      description: 'Experience sustained energy levels throughout the day without afternoon crashes.'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Enhanced Mood',
      description: 'Achieve emotional balance and mental clarity with optimized hormone levels.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Improved Libido',
      description: 'Restore sexual vitality and intimate wellness for a fulfilling relationship.'
    },
    {
      icon: 'ri-moon-line',
      title: 'Better Sleep',
      description: 'Enjoy deeper, more restorative sleep patterns for optimal recovery.'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Weight Management',
      description: 'Support healthy metabolism and body composition with balanced hormones.'
    },
    {
      icon: 'ri-brain-line',
      title: 'Mental Clarity',
      description: 'Enhance cognitive function, focus, and memory retention.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Cardiovascular Health',
      description: 'Support heart health and circulation with optimal hormone balance.'
    },
    {
      icon: 'ri-bone-line',
      title: 'Bone Density',
      description: 'Maintain strong bones and prevent age-related bone loss.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Transform Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Quality of Life</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Bioidentical hormone optimization addresses the root cause of age-related decline, 
            helping you feel like your younger, more vibrant self again.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
              <div className="w-20 h-20 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:shadow-lg">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-pink-50 to-purple-50 rounded-2xl p-8 lg:p-12">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Why Choose Bioidentical Hormones?
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-leaf-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">Natural Structure</h4>
                <p className="text-gray-600">Molecularly identical to hormones produced by your body for optimal compatibility.</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">Personalized Dosing</h4>
                <p className="text-gray-600">Customized to your unique hormone levels and individual response patterns.</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">Safer Profile</h4>
                <p className="text-gray-600">Reduced side effects compared to synthetic hormone alternatives.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;